export default __webpack_public_path__ + "884db4fe5449d4aa1288fb8814162484.png";